// This icon file is generated automatically.
var PTagOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.66 6.17l-.47-4.89a.53.53 0 00-.47-.47L7.83.34A.16.16 0 007.7.4L.39 7.7a.16.16 0 000 .22l5.68 5.68c.03.03.07.05.11.05.05 0 .09-.02.12-.05L13.6 6.3a.16.16 0 00.05-.12zm-7.48 5.87L1.96 7.82 8.2 1.57l3.86.37.37 3.86-6.25 6.24zM9.63 3a1.38 1.38 0 100 2.75 1.38 1.38 0 000-2.75zm0 1.88a.5.5 0 110-1 .5.5 0 010 1z", "fill-rule": "nonzero" } }] }, "name": "p-tag", "theme": "outlined" };
export default PTagOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PTagOutlined.js
// module id = 3674
// module chunks = 0